<template>
    <div>
        <header
            id="header"
            class="navbar navbar-expand-lg navbar-fixed navbar-height navbar-flush navbar-bordered"
        >
            <div class="navbar-nav-wrap offset-1 col-10">
                <div class="navbar-brand-wrapper">
                    <!-- Logo -->
                    <Link
                        class="navbar-brand"
                        :href="route('home')"
                        aria-label="Front"
                    >
                        <img
                            class="navbar-brand-logo d-none d-xl-block img-fluid"
                            src="../../images/logo/logo.svg"
                            alt="Logo"
                        />
                        <img
                            class="navbar-brand-logo d-xl-none my-auto img-fluid"
                            src="../../images/logo/logo.svg"
                            alt="Logo"
                        />
                    </Link>
                    <!-- End Logo -->
                </div>

                <div class="navbar-nav-wrap-content-left"></div>

                <!-- Secondary Content -->
                <div class="navbar-nav-wrap-content-right">
                    <!-- Navbar -->
                    <ul class="navbar-nav align-items-center flex-row">
                        <li class="nav-item d-none d-sm-inline-block">
                            <div class="hs-unfold"></div>
                            <!-- End Notification -->
                        </li>
                        <li class="nav-item">
                            <a
                                class="text-black pr-1 font-16px underlined-anchor"
                                >Ita</a
                            >
                            <a class="text-black pr-2 font-16px">Eng</a>
                            <!-- Account -->
                            <div class="hs-unfold">
                                <a
                                    class="js-hs-unfold-invoker navbar-dropdown-account-wrapper"
                                    href="#"
                                    data-hs-unfold-options='{"target": "#accountNavbarDropdown","type": "css-animation"}'
                                    data-hs-unfold-target="#accountNavbarDropdown"
                                    data-hs-unfold-invoker=""
                                >
                                    <div class="avatar avatar-circle">
                                        <div
                                            class="avatar avatar-soft-primary avatar-circle mr-2"
                                        >
                                            <img
                                                src="../../images/header/profile_icon.svg"
                                            />
                                        </div>
                                    </div>
                                </a>

                                <div
                                    id="accountNavbarDropdown"
                                    class="hs-unfold-content dropdown-unfold dropdown-menu dropdown-menu-right navbar-dropdown-menu navbar-dropdown-account hs-unfold-hidden hs-unfold-content-initialized hs-unfold-css-animation animated"
                                    style="
                                        animation-duration: 300ms;
                                        margin-top: -40px;
                                    "
                                    data-hs-target-height="394.281"
                                    data-hs-unfold-content=""
                                    data-hs-unfold-content-animation-in="slideInUp"
                                    data-hs-unfold-content-animation-out="fadeOut"
                                >
                                    <a class="dropdown-item" href="#">
                                        <form
                                            method="POST"
                                            @submit.prevent="logout"
                                        >
                                            <button
                                                class="btn text-black font-weight-normal text-truncate pr-2"
                                                type="submit"
                                            >
                                                Logout
                                            </button>
                                        </form>
                                    </a>
                                </div>
                            </div>
                            <!-- End Account -->
                        </li>
                    </ul>
                    <!-- End Navbar -->
                </div>
                <!-- End Secondary Content -->
            </div>
        </header>

        <!-- main -->
        <main>
            <div class="container">
                <slot></slot>
            </div>
        </main>

        <!-- Modal Portal -->
        <portal-target name="modal" multiple> </portal-target>
    </div>
</template>

<script>
import JetApplicationMark from "../Jetstream/ApplicationMark";
import JetBanner from "../Jetstream/Banner";
import JetDropdown from "../Jetstream/Dropdown";
import JetDropdownLink from "../Jetstream/DropdownLink";
import JetNavLink from "../Jetstream/NavLink";
import JetResponsiveNavLink from "../Jetstream/ResponsiveNavLink";
import { Link } from "@inertiajs/vue2";

export default {
    components: {
        JetApplicationMark,
        JetBanner,
        JetDropdown,
        JetDropdownLink,
        JetNavLink,
        JetResponsiveNavLink,
        Link,
    },

    data() {
        return {
            showingNavigationDropdown: false,
        };
    },

    methods: {
        switchToTeam(team) {
            this.$inertia.put(
                route("current-team.update"),
                {
                    team_id: team.id,
                },
                {
                    preserveState: false,
                }
            );
        },

        logout() {
            this.$inertia.post(route("logout"));
        },
    },
};
</script>
